import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e5edd8ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "blue" }
const _hoisted_2 = {
  class: "template",
  id: "contact"
}
const _hoisted_3 = ["data-aos"]
const _hoisted_4 = ["data-aos"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "email" }, "askchrisn@gmail.com", -1))

import { useLanguageSwitcher } from '@/composables/useLanguageSwitcher';
import { FadeDown, FadeUp } from '@/constants/app';
import { Icon } from '@iconify/vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Contact',
  setup(__props) {

const { t } = useLanguageSwitcher();


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", {
        "data-aos": _unref(FadeDown),
        class: "title"
      }, _toDisplayString(_unref(t)('contact.title')), 9, _hoisted_3),
      _createElementVNode("div", {
        "data-aos": _unref(FadeUp),
        class: "content"
      }, [
        _createVNode(_unref(Icon), {
          icon: "clarity:email-solid",
          width: "35"
        }),
        _hoisted_5
      ], 8, _hoisted_4)
    ])
  ]))
}
}

})